'use client';

import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { useMemo, useState } from 'react';

import { publicEnv } from '@/lib/env';

interface VideoPlayerProps {
  featuredVideo: string;
  featuredImage: string;
}

function VideoPlayer({ featuredVideo, featuredImage }: VideoPlayerProps) {
  const [showFeaturedImage, setShowFeaturedImage] = useState(!!featuredImage);
  const handleClick = () => {
    setShowFeaturedImage(false);
  };

  const videoSrc = useMemo(() => {
    let videoId;
    if (featuredVideo.includes('youtube.com')) {
      videoId = featuredVideo.split('v=')[1];
      return `https://www.youtube.com/embed/${videoId}?autoplay=0`; //autoplay=1
    } else {
      videoId = featuredVideo.split('vimeo.com/')[1];
      return `https://player.vimeo.com/video/${videoId}?autoplay=0`;
    }
  }, [featuredVideo]);

  return (
    <div className='mt-6'>
      {!showFeaturedImage ? (
        <iframe
          width='100%'
          src={videoSrc}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
          title='Embedded youtube'
          className='h-[240px] rounded-xl border shadow-md sm:h-[500px]'
        />
      ) : (
        <div className='relative cursor-pointer' onClick={handleClick}>
          <img
            src={featuredImage}
            alt=''
            width={996}
            height={500}
            className='h-auto w-full rounded-xl border shadow-md'
          />
          <div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'>
            <img
              src={getCDNURL(
                `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/play-button.svg`,
                160,
                160
              )}
              alt='play button'
              width={160}
              height={160}
              className='size-32 sm:size-40'
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoPlayer;
